
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[address]",
      function () {
        return require("private-next-pages/[address].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[address]"])
      });
    }
  